import { OPERA_COUNTRY_CODES } from './country-codes';

export const getOperaCountryCodes = () =>
  OPERA_COUNTRY_CODES.map((country) => country.code);
